import { PlaneIcon, MapPinIcon, LandmarkIcon } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export type ServiceId = 'airport' | 'destination' | 'citytour'

export interface RentalService {
  id: ServiceId
  label: string
  short: string
  description: string
  icon: LucideIcon
}

export const services: RentalService[] = [
  {
    id: 'airport',
    label: 'Airport Rental',
    short: 'Airport',
    description:
      'On-time pickups and drop-offs to the airport with flight tracking and a meet-and-greet at arrivals.',
    icon: PlaneIcon,
  },
  {
    id: 'destination',
    label: 'Destination Rental',
    short: 'Destination',
    description:
      'Book a car with driver for long routes and intercity trips — pay by day or by the full journey.',
    icon: MapPinIcon,
  },
  {
    id: 'citytour',
    label: 'City Tour Rental',
    short: 'City Tour',
    description:
      'Explore the city at your own pace with a local driver, flexible stops and hourly or full-day plans.',
    icon: LandmarkIcon,
  },
]
